import { memo } from 'react';

import { Box, Typography } from '@mui/material';

import { stepHeaderPillLabelSx, stepHeaderPillSx } from './step-header-pill-styles';

interface StepHeaderLabelPillProps {
  label: string;
}

export const StepHeaderLabelPill = memo(({ label }: StepHeaderLabelPillProps) => (
  <Box sx={stepHeaderPillSx()}>
    <Typography component="span" sx={stepHeaderPillLabelSx}>
      {label}
    </Typography>
  </Box>
));

StepHeaderLabelPill.displayName = 'StepHeaderLabelPill';
